import {Component, OnInit} from '@angular/core';
import {Observable} from "rxjs";
import {UserService} from "../../services/user.service";
import {UserRequest} from "../../model/UserRequest";

import {AdminPageModelComponent} from "../../components/admin/admin-page-model/admin-page-model.component";
import {UserRequestsComponent} from "../../components/admin/user-requests/user-requests.component";

@Component({
    selector: 'app-user-edit-request',
    templateUrl: './user-edit-request.component.html',
    imports: [
    AdminPageModelComponent,
    UserRequestsComponent
],
    styleUrl: './user-edit-request.component.scss'
})
export class UserEditRequestComponent implements OnInit {
  requests = new Observable<UserRequest[]>();

  constructor(private userRequestService: UserService) {
  }

  ngOnInit(): void {
    this.requests = this.userRequestService.listEditRequests();
  }

}
